import ArtistProfileFilter from "components/filters/Filters/ArtistProfileFilter";
import FavoriteArtistsFilter from "components/filters/Filters/FavoriteArtistsFilter";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import TagFilter from "components/filters/Filters/TagFilter";
import React from "react";

interface FiltersProps {
  initialTags: server.dto.TagSmall[]
}

const Filters = (props: FiltersProps) => {
  return <>
    <KeywordFilter
      placeholder={RESX.GeneralLabels.Keyword}
    />
    <FavoriteArtistsFilter
    />
    <ArtistProfileFilter
    />
    <TagFilter
      mainArea="company"
      initialTags={props.initialTags}
    />
  </>;
};

export default Filters;